import { FormControlLabel, Switch, Typography, useTheme } from '@mui/material'
import { msg } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useLayoutMode } from '../contexts/layout-mode-context'

/**
 * Toggle between mobile and desktop UI. Rendered only in the touch-tablet viewport band.
 */
export default function LayoutModeSwitch({ compact = false, inverted = false }) {
  const { _ } = useLingui()
  const theme = useTheme()
  const { isTabletTouchZone, layoutPreference, setLayoutPreference } = useLayoutMode()

  if (!isTabletTouchZone) {
    return null
  }

  const label = _(msg`Mobile layout`)
  const onDarkToolbar = inverted || compact
  const labelColor = onDarkToolbar
    ? '#fff'
    : theme.palette.text.primary

  return (
    <FormControlLabel
      sx={{
        m: 0,
        flexShrink: 0,
        userSelect: 'none',
        color: onDarkToolbar ? '#fff' : undefined,
        '& .MuiFormControlLabel-label': {
          color: labelColor,
          fontSize: compact ? '0.75rem' : '0.875rem',
        },
      }}
      label={
        compact ? (
          <Typography
            component="span"
            variant="caption"
            sx={{ color: labelColor, whiteSpace: 'nowrap' }}
          >
            {label}
          </Typography>
        ) : (
          <Typography
            component="span"
            sx={{
              color: labelColor,
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Typography>
        )
      }
      control={
        <Switch
          size={compact ? 'small' : 'medium'}
          checked={layoutPreference === 'mobile'}
          onChange={(event) =>
            setLayoutPreference(event.target.checked ? 'mobile' : 'desktop')
          }
          inputProps={{ 'aria-label': label }}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#fff',
            },
            '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
              backgroundColor: '#fff',
            },
            ...(inverted || compact
              ? {
                  '& .MuiSwitch-thumb': {
                    backgroundColor: '#fff',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: 'rgba(255, 255, 255, 0.35)',
                    opacity: 1,
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: 'rgba(255, 255, 255, 0.55)',
                    opacity: 1,
                  },
                }
              : {}),
          }}
        />
      }
    />
  )
}
